import { type FC } from 'react';
import * as Styled from './styled';

export type Props = {
  children: React.ReactNode;
};

export const Actions: FC<Props> = ({ children }) => {
  if (!children) {
    return null;
  }

  return <Styled.Wrapper>{children}</Styled.Wrapper>;
};
